import { Grid, makeStyles, Tooltip, Typography } from '@material-ui/core';
import { useStore } from '@roc/client-portal-shared/hooks';
import { GreenArrow, RedArrow } from '@roc/feature-comp-tool';
import { valueOrDash } from '@roc/feature-valuation-review-v2';

const useStyles = makeStyles(() => ({
  value: {
    maxWidth: "150px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    textAlign: "center",
  }
}));

export type PropertyDetailProps = {
  label: string;
  value: any;
  lg: any;
  xs?: any;
  variant: any;
  md: any;
  addArrow?: boolean;
  field?: string
  showTooltip?: boolean;
};

export const PropertyDetail = (props: PropertyDetailProps) => {
  const { compToolStoreV2: compToolStore } = useStore();
  const { label, value, lg, xs, variant, md, addArrow = false, field = '', showTooltip = false } = props;
  const classes = useStyles();

  const getArrowSymbol = () => {
    if (addArrow && compToolStore.subjectProperty.data[field] && value) {
      if (compToolStore.subjectProperty.data[field] > value) {
        return <RedArrow style={{ height: '38px', width: '20px' }} />;
      } else if (compToolStore?.subjectProperty.data[field] < value) {
        return <GreenArrow style={{ height: '38px', width: '20px' }} />;
      }
    }
    return null;
  }


  return (
    <Grid item lg={lg} xs={xs} md={md} style={{ alignContent: 'center' }}>
      <Tooltip title={showTooltip ? value : ""} placement="top" arrow>
        <Typography align="center" className={classes.value} variant={variant} gutterBottom>
          {valueOrDash(value)}{addArrow && getArrowSymbol()}
        </Typography>
      </Tooltip>
      <Typography align="center" variant="body2" color="textSecondary">
        {label}
      </Typography>
    </Grid>
  );
};